import { Flex } from "styled-system/jsx";
import { useTranslation } from "react-i18next";
import { Text } from "@ttc3k/trekker";
import { ControlledInput, ControlledSelectRoot } from "shared/components";
import { Select } from "@ttc3k/trekker";
import { AddOperatorFormValues } from "apps/directory/Operator/components/AddOperatorModal/useAddOperatorForm.ts";
import { useFormContext, useWatch } from "react-hook-form";
import { businessTypeOptions } from "shared/constants";

export const BusinessInfoScreen = () => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<AddOperatorFormValues>();
  const businessType = useWatch({ control, name: "businessType" });

  const handleSelectBusinessType = (businessType: string) => {
    setValue("businessType", businessType);
  };

  return (
    <Flex flexDir={"column"} gap={"150"}>
      <Text visual={"bodySemiBold"} color={"text.mid"}>
        {t("directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.TITLE")}
      </Text>
      <ControlledInput
        name={"businessName"}
        label={t(
          "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.BUSINESS_NAME",
        )}
      />
      <Flex gap={"150"}>
        <ControlledInput
          name={"email"}
          label={t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.PUBLIC_EMAIL_ADDRESS",
          )}
          type="email"
        />
        <ControlledInput
          name={"website"}
          label={t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.PUBLIC_WEBSITE",
          )}
        />
      </Flex>
      <Flex gap={"150"}>
        <ControlledInput
          name={"phone"}
          label={t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.LOCAL_PUBLIC_PHONE",
          )}
        />
        <ControlledInput
          name={"tollFreePhone"}
          label={t(
            "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.TOLL_FREE_PUBLIC_PHONE",
          )}
        />
      </Flex>
      <ControlledSelectRoot
        name={"businessType"}
        items={businessTypeOptions}
        value={[businessType]}
        label={t(
          "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.BUSINESS_TYPE.TITLE",
        )}
        placeholder={t(
          "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.BUSINESS_TYPE.PLACEHOLDER",
        )}
        onValueChange={({ value }: { value: string[] }) =>
          handleSelectBusinessType(value[0])
        }
      >
        {businessTypeOptions.map((businessTypeOpt) => (
          <Select.Item key={businessTypeOpt.value} item={businessTypeOpt} />
        ))}
      </ControlledSelectRoot>
    </Flex>
  );
};
